import { useState } from "react";

import "./Styles/AddComment.scss";

const AddComment = ({ buttonValue, onSubmit, replyingTo, parentId }) => {
  const replyingToUser = replyingTo ? `@${replyingTo}, ` : "";
  const [comment, setComment] = useState("");

  const clickHandler = () => {
    if (comment.trim() === "") return;

    const commentText = replyingToUser + comment;

    onSubmit({
      text: commentText,
      parentId: parentId, // Pass parentId if available
    });

    setComment("");
  };

  return (
    <>
    {/* test AddComment.js */}
    <div className="add-comment">
      <div className="profile-pic"></div>
      <textarea
        className="comment-input"
        placeholder="Add a comment"
        value={replyingToUser + comment}
        onChange={(e) => {
          setComment(
            e.target.value.replace(replyingTo ? `@${replyingTo}, ` : "", "")
          );
        }}
      />
      <div className="send-btn-container">
        {/* <div className="profile-pic"></div> */}

        {/* <img
          className="profile-pic"
          src={commentData.avatarUrl}
          alt={`${commentData.username}'s avatar`}
        /> */}

        <button className="add-btn" onClick={clickHandler}>
          {buttonValue}
        </button>
      </div>
    </div>
    </>
  );
};

export default AddComment;
